// extracted by mini-css-extract-plugin
export default {"nav":"tabs_nav__dp0a8","active":"tabs_active__RTMDi","nav1":"tabs_nav1__1yEZL"};